import api from '../services/api';
import Swal from 'sweetalert2';

export default function RecuperarSenha() {
  const container = document.createElement('div');
  container.innerHTML = ``;

  Swal.fire({
    title: 'Recuperar Senha',
    html: `
      <label for="email" class="swal2-label" style="margin-bottom:5px;">Email</label>
      <input id="email" class="swal2-input" type="email" placeholder="Digite seu email" style="margin:0;" />
    `,
    confirmButtonText: 'Enviar',
    cancelButtonText: 'Cancelar',
    showCancelButton: false,
    focusConfirm: false,
    background: '#fff',   // fundo branco
    color: '#000',        // texto preto
    customClass: {
      popup: 'swal-recuperar-senha'
    },
    preConfirm: async () => {
      const email = document.getElementById('email').value;

      try {
        const res = await api.post('/recuperarsenha', { email });
        Swal.fire('✅ Sucesso', 'Uma nova senha foi enviada para seu email. Verique Caixa de Entrada e SPAM', 'success');
      } catch (error) {
        Swal.showValidationMessage(
          error.response?.data?.message || 'Erro ao enviar email'
        );
      }
    }
  });

  return container;
}
